import { useNavigate } from "react-router-dom";

const SuccessModal = () => {
  const navigate = useNavigate();

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4"
      role="dialog"
      aria-labelledby="success-modal-title"
      aria-modal="true"
    >
      <div className="bg-white w-full max-w-sm md:max-w-md p-6 rounded-lg shadow-lg text-center">
        <div className="w-20 h-20 bg-[#8ED6A8] rounded-full flex items-center justify-center mx-auto">
          <img src="/green-tick.png" alt="Success" className="w-12 h-12" />
        </div>

        <h2
          id="success-modal-title"
          className="text-black text-lg font-semibold mt-4"
        >
          File Uploaded Successfully!
        </h2>
        <p className="text-black text-sm mt-2">
          We have successfully uploaded your file. Proceed to preview.
        </p>

        <button
          className="bg-[#005C53] text-white w-full max-w-xs h-12 rounded-lg mt-5"
          onClick={() => navigate("/dashboard/bulk-repayment/preview")}
        >
          Continue to Preview
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
